import { Container, Grid } from '@material-ui/core';
import React, { useState } from 'react';
import { useEventListener } from 'utils/use-event-listener';
import { CatalogueBarProps } from './catalogue-bar-props';
import './catalogue-bar.scss';

export const CatalogueBar: React.FC<CatalogueBarProps> = (props) => {
  const [isSticky, setIsSticky] = useState<boolean>(false);

  const stickHeaders = () => {
    if (window.scrollY > 0) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEventListener('scroll', stickHeaders);

  return (
    <div className={`sg-catalogue-bar ${isSticky ? 'sg-catalogue-bar--sticky' : ''}`}>
      <Container className="sg-catalogue-bar__container">
        <Grid container item xs={12}>
          <Grid item xs={12} sm={6}>
            <h2>{props.title}</h2>
          </Grid>
          <Grid item xs={12} sm={6} />
        </Grid>
      </Container>
    </div>
  );
};
